<template>
  <div :id="playerId" class="xgplayer-container"></div>
</template>

<script>
export default {
  name: "XGPlayer",
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
      default: "",
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: "100%",
    },
    height: {
      type: [String, Number],
      default: "",
    },
    posterHeight: {
      type: [String, Number],
      default: "auto",
    },
    extraOptions: {
      type: Object,
      default: () => ({}),
    },
    startPlayIcon: {
      type: String,
      default: "",
    },
    startPauseIcon: {
      type: String,
      default: "",
    },
    fluid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      playerId: `xgplayer-${Math.random().toString(36).substring(7)}`, // 生成唯一的播放器ID
      player: null, // 存储播放器实例
    };
  },
  beforeDestroy() {
    // 在组件销毁时销毁播放器
    this.destroyPlayer();
  },
  methods: {
    /**
     * 初始化播放器
     */
    initPlayer() {
      const {
        videoUrl,
        poster,
        autoPlay,
        width,
        height,
        extraOptions,
        posterHeight,
        startPlayIcon,
        startPauseIcon,
        fluid,
      } = this;

      // 初始化播放器
      YCF_Plugin.initXGPlayer({
        selector: `#${this.playerId}`, // 容器选择器
        url: videoUrl, // 视频地址
        poster: poster, // 视频封面图
        autoplay: false, // 自动播放
        width: width, // 播放器宽度
        height: height || 300, // 播放器高度
        posterHeight: posterHeight || "300px", // 封面图高度
        extraOptions: extraOptions, // 额外配置项
        startPlay: startPlayIcon || "", // 播放按钮图标
        startPause: startPauseIcon || "", // 暂停按钮图标
        fluid: fluid, // 是否启用流式布局
        onReady: (players) => {
          this.player = players[0]; // 获取播放器实例

          // 监听播放事件
          this.player.on("play", () => {
            this.$emit("play"); // 触发播放事件
          });

          // 监听暂停事件
          this.player.on("pause", () => {
            this.$emit("pause"); // 触发暂停事件
          });

          // 监听聚焦事件
          this.player.on("focus", () => {
            this.$emit("focus"); // 触发聚焦事件
          });

          // 监听失焦事件
          this.player.on("blur", () => {
            this.$emit("blur"); // 触发失焦事件
          });

          this.$emit("onReady", this.player); // 播放器准备完成，触发回调并传递实例
        },
      });
    },

    /**
     * 销毁播放器
     */
    destroyPlayer() {
      if (this.player) {
        this.player.destroy(); // 调用播放器的销毁方法
        this.player = null; // 清空实例
      }
    },
  },
  watch: {
    // showCoverImg:{
    //   immediate: true, // 初始化时立即触发
    //   handler(newVal) {
    //     // 如果 videoUrl 有值才销毁并重新初始化播放器
    //     if (!newVal) {
    //       this.destroyPlayer(); // 销毁旧播放器
    //       this.$nextTick(() => {
    //         this.initPlayer(); // 重新初始化播放器
    //       });
    //     }
    //   },
    // },
    videoUrl: {
      immediate: true, // 初始化时立即触发
      handler(newVal) {
        // 如果 videoUrl 有值才销毁并重新初始化播放器
        if (newVal) {
          this.destroyPlayer(); // 销毁旧播放器
          this.$nextTick(() => {
            this.initPlayer(); // 重新初始化播放器
          });
        }
      },
    },
  },
};
</script>

<style lang="scss">
.xgplayer-container {
  // position: absolute;
  // top: 0;
  // left: 0;
}
.xgplayer .xgplayer-progress-played {
  background: linear-gradient(133deg, #ff872e, #ff672e) !important;
}
</style>
